export class AppointmentHubHero extends DrupalBehavior {
  onContent(context) {
    const triggerBtn = document.getElementById('toggle-proxy-button');

    // Add an event listener to the trigger element after the DOM loads
    triggerBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetBtn = document.getElementById('toggle-widget-button');
      targetBtn.click();
    });
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_hub_hero',
  AppointmentHubHero
);
